/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsuploadmenu3Inputs */

const en_listingbuttonsuploadmenu3 = /** @type {(inputs: Listingbuttonsuploadmenu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`upload one now`)
};

const de_listingbuttonsuploadmenu3 = /** @type {(inputs: Listingbuttonsuploadmenu3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jetzt hochladen`)
};

/**
* | output |
* | --- |
* | "upload one now" |
*
* @param {Listingbuttonsuploadmenu3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsuploadmenu3 = /** @type {((inputs?: Listingbuttonsuploadmenu3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsuploadmenu3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsuploadmenu3(inputs)
	return de_listingbuttonsuploadmenu3(inputs)
});
export { listingbuttonsuploadmenu3 as "listingButtonsUploadMenu" }